import { __extends } from "tslib";
import { deserializeAws_restXmlGetBucketLoggingCommand, serializeAws_restXmlGetBucketLoggingCommand } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetBucketLoggingCommand = /** @class */ (function (_super) {
    __extends(GetBucketLoggingCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetBucketLoggingCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetBucketLoggingCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetBucketLoggingCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlGetBucketLoggingCommand(input, context);
    };
    GetBucketLoggingCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlGetBucketLoggingCommand(output, context);
    };
    return GetBucketLoggingCommand;
}($Command));
export { GetBucketLoggingCommand };
//# sourceMappingURL=GetBucketLoggingCommand.js.map